import {
  KeywordSummaryAudioHighlightMetadata,
  ReasonSummaryAudioHighlightMetadata,
} from '@modules/feedback/components/AudioType/types';

export const getSummaryTextIndexFromHighlightMetadataMatches = (
  highlightMetadataMatches: (
    | KeywordSummaryAudioHighlightMetadata
    | ReasonSummaryAudioHighlightMetadata
  )[],
  summaryText: string,
): number => {
  if (highlightMetadataMatches.length <= 1) {
    return 0;
  }

  const summaryTextLastIndexMap = new Map<string, number>();

  highlightMetadataMatches.forEach((highlightMatch, index) => {
    summaryTextLastIndexMap.set(highlightMatch.summaryText, index);
  });

  return summaryTextLastIndexMap.get(summaryText) ?? 0;
};
